// Copyright (c) Tangible It, Mexico. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import ReactTooltip from "react-tooltip";

import axios from "axios";

import Header from "../../components/Header/Header";
import { toast } from "react-toastify";

import "./Assignment.css";

import Controls from "./Components/Controls/Controls";
import {
  CloseIcon,
  IndentIcon,
  NumberListIcon,
} from "@fluentui/react-icons-northstar";

import {
  Text,
  Card,
  Image,
  Label,
  Flex,
  Dialog,
  Tooltip,
  Popup,
} from "@fluentui/react-northstar";
import moment from "moment";

import { withTranslation } from "react-i18next";

import Imgart from "../../Assets/images/subjects/art.png";
import Imgcivil from "../../Assets/images/subjects/civil.png";
import Imghistory from "../../Assets/images/subjects/history.png";
import ImgnaturalScience from "../../Assets/images/subjects/natural-science.png";
import Imgphilosophy from "../../Assets/images/subjects/philosophy.png";
import ImgscienceExact from "../../Assets/images/subjects/science-exact.png";
import Imgtech from "../../Assets/images/subjects/tech.png";
import Imgother from "../../Assets/images/subjects/other.png";
import AssignmentHomeSvg from "../../Assets/images/svg/AssignmentHome.svg";
import AssignmentHome from "./Components/AssignmentHome/AssignmentHome";

import { AssignmentContext } from "../../context/AssignmentContext";
import { Subscription } from "../../components/Subscription/Subscription";
import CustomProgressIndicator from "../../components/Loader/CustomProgressIndicator";
import AvailbleClass from "../Attendance/AvailbleClass";
import i18n from "../../helper/i18n";

const url = process.env.REACT_APP_EP_URL;

const v = new Date(new Date().setHours(0, 0, 0, 0));
// const v = new Date(new Date().setUTCHours(0,0,0,0))
let headers;
class Assignment extends React.Component {
  static contextType = AssignmentContext;
  constructor(props) {
    super(props);
    this.state = {
      lessions: [],
      records: [],
      selectedLesson: null,
      showLesson: [],
      showRecords: [],
      showRecordsAnalytics: {
        virtual: 0,
        total: 0,
        present: 0,
        absent: 0,
        late: 0,
        justification: 0,
      },
      showTopic: false,
      showNote: false,
      selectedDate: v.toISOString(),
      selectedClass: null,
      selectedTeacher: null,
      response: {},
      checkAll: false,
      checkedRecords: [],
      checkedRecordsMode: [],
      onLine: null,
      load: false,
      dialog: false,
      isExpire: false,
      accDlg: false,
      selectedLessonType: false,
      isCompactMode: false,
      isSmall: false,
      isDateSelected: false,
      isSubscribed: false,
      isOpen: false,
      getSelectedData: v,
      selectedDay: null,
      isCreatingRubric: false,
      isOpenAvatarGenerator: false,
      showLessonSwitchConfirm: false,
    };
  }

  //choose the screen size
  handleResize = (val) => {
    if (window.innerWidth < 375) {
      this.setState({ isSmall: true });
    } else {
      this.setState({ isSmall: false });
    }
    if (val === "TOPIC") {
      if (window.innerWidth < 1000) {
        this.setState({
          showNote: false,
        });
        this.setState({ showTopic: !this.state.showTopic });
      } else {
        this.setState({ showTopic: !this.state.showTopic });
        this.state.showNote && this.setState({ showNote: true });
      }
    } else {
      if (window.innerWidth < 1000) {
        this.setState({
          showTopic: false,
        });
        this.setState({ showNote: !this.state.showNote });
      } else {
        this.setState({ showNote: !this.state.showNote });
        this.state.showTopic && this.setState({ showTopic: true });
      }
    }
  };

  async componentDidMount() {
    const wiseDay = this.state?.getSelectedData?.getDay() || v.getDay();
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    this.setState({ selectedDay: days[wiseDay] });

    headers = {
      Authorization: "Bearer " + this.props.user.accessToken,
    };
    if (
      location.pathname === "/assignments/assignmnet/rubric" ||
      location.pathname === "/assignments/create"
    ) {
      this.props.history.push("/assignments");
    }
    const subscription = JSON.parse(localStorage.getItem("subscription"));
    if (subscription && subscription?.assingment) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }

    if (
      this.props.user?.dbData?.subscription &&
      this.props.user?.dbData?.subscription?.assingment
    ) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }

    if (this.props.user?.dbData?.dayRemaining <= 2) {
      if (this.props.user?.dbData?.ExpirationDate) {
        if (this.props.user?.dbData?.dayRemaining <= 0) {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: false,
            isExpire: true,
          });
        } else {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: true,
            isExpire: false,
          });
        }
      }
    }

    // this.getAllLessons();
    this.fetchLessons();

    if (navigator.onLine) {
      this.setState({ onLine: navigator.onLine });
    }

    window.addEventListener("offline", (e) => {
      console.log(e, "you're offline");
      this.setState({ onLine: navigator.onLine });
    });
  }

  componentDidUpdate = async (prevProps, prevState) => {
    if (
      this.props.user.slug === "?slug=acvpreprod" ||
      this.props.user.slug === "?slug=acvapp"
    ) {
      if (prevState.selectedDate !== this.state.selectedDate) {
        const wiseDay = this.state?.getSelectedData?.getDay();
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        this.setState({ selectedDay: days[wiseDay] });
      }
    }

    //Check to see if a Graph access token is now in state AND that it didn't exist previously
    if (prevProps.user.slug !== this.props.user.slug) {
      this.fetchLessons();
    }
  };

  getAllLessons = () => {
    axios
      .get(`${url}/api/lession/get-lessions${this.props.user.slug}`, {
        headers: headers,
      })
      .then((res) => {
        const lessions = res.data;
        this.setState({ lessions });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  fetchLessons = (note) => {
    this.setState({ load: true });
    if (!note) {
      this.setState({ selectedLesson: null, showRecords: [] });
    }
    const lessonData = JSON.parse(localStorage.getItem("selectedLession"));

    if (lessonData) {
      if (this.state.selectedDate === lessonData.LessonDate) {
        this.setState(
          {
            selectedLesson: lessonData,
          },
          () => this.fetchRecordsByLesson(),
        );
      }
    }

    if (document.querySelector(".h-cls")) {
      document.querySelector(".h-cls").classList.remove("h-cls");
    }
    const selectedDate = this.state.selectedDate;
    const selectedClass = this.state.selectedClass;
    const selectedTeacher = this.state.selectedTeacher;

    axios
      .post(
        `${url}/api/lession/get-lession-by-teacher${this.props.user.slug}&pageName=assingment`,
        {
          ClassName: selectedClass,
          TeacherEmailAlias: selectedTeacher,
          LessonDate: selectedDate,
        },
        { headers: headers },
      )
      .then((res) => {
        const showLesson = res.data.result.sort((a, b) =>
          a.StartTime.toLowerCase() > b.StartTime.toLowerCase() ? 1 : -1,
        );
        this.setState({ showLesson });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      })
      .finally(() => {
        this.setState({ load: false });
      });
  };

  fetchRecordsByLesson = () => {
    const lessonTitle = this.state.selectedLesson?.Title
      ? this.state.selectedLesson.Title
      : this.state.selectedLesson?.LessonId;
    axios
      .get(
        `${url}/api/record/get-record-by-lession/${lessonTitle}${this.props.user.slug}`,
        { headers: headers },
      )
      .then((res) => {
        const showRecords = res.data.result;
        // console.log("showRecords ::: ", showRecords);
        if (res.data.result.length) {
          const selectedLessonType = res.data.result[0].ClassType;
          this.setState({ showRecords, selectedLessonType });
        } else {
          axios
            .get(
              `${url}/api/lession/get-lesson-class-type/${lessonTitle}${this.props.user.slug}`,
              { headers: headers },
            )
            .then((res) => {
              const selectedLessonType = res.data?.result?.ClassType;
              this.setState({ showRecords, selectedLessonType });
            })
            .catch((err) => {
              toast.error(err?.response?.data?.message);
              console.log(err, err.response);
              if (err.response?.status === 401) {
                this.setState({ accDlg: true });
              }
            });
        }
      })
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      })
      .finally(() => {
        this.setState({ load: false });
      });
  };

  lessonTopicHandler = () => {
    const lessonTitle = this.state.selectedLesson?.Title
      ? this.state.selectedLesson.Title
      : this.state.selectedLesson?.LessonId;
    axios
      .put(
        `${url}/api/lession/update-class-topic/${lessonTitle}${this.props.user.slug}`,
        {
          Tema: document.getElementById("textLessonTopic").value,
        },
        { headers: headers },
      )
      .then((res) => {
        // console.log(res);
        this.fetchLessons("note");
        const status = res.data.status;
        if (status === "Success") {
          this.setState({ showTopic: false });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  lessonNoteHandler = () => {
    const lessonTitle = this.state.selectedLesson?.Title
      ? this.state.selectedLesson.Title
      : this.state.selectedLesson?.LessonId;
    axios
      .put(
        `${url}/api/lession/update-class-note/${lessonTitle}${this.props.user.slug}`,
        {
          Tarea: document.getElementById("textLessonNote").value,
        },
        { headers: headers },
      )
      .then((res) => {
        this.fetchLessons("note");
        const status = res.data.status;
        if (status === "Success") {
          this.setState({ showNote: false });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  studentNoteHandler = (email, lsn, note) => {
    axios
      .put(
        `${url}/api/record/update-student-note${this.props.user.slug}`,
        {
          StudentEmailId: email,
          LessonId: lsn,
          Notes: note === null ? "" : note,
        },
        { headers: headers },
      )
      .then((res) => {
        const status = res.data.status;
        if (status === "Success") {
          const foundRecord = this.state.showRecords.find((stud) => {
            return stud.StudentEmailId === email
              ? stud.LessonId === lsn
                ? stud.LessonId === lsn
                : null
              : null;
          });
          const foundIndex = this.state.showRecords.findIndex((stud) => {
            return stud.StudentEmailId === email
              ? stud.LessonId === lsn
                ? stud.LessonId === lsn
                : null
              : null;
          });
          let recordData = [...this.state.showRecords];
          foundRecord.Notes = note;
          recordData[foundIndex] = foundRecord;
          this.setState({ showRecords: recordData });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  checkedRecordsHandler = (attendance, takenBy) => {
    let chkRecords = [...this.state.checkedRecords];
    chkRecords = chkRecords.map((student) => {
      return {
        Attendance: attendance,
        AttendanceTakenBy: takenBy,
        ClassId: student.ClassId,
        ClassName: student.ClassName,
        EndTime: student.EndTime,
        LessonDate: student.LessonDate,
        LessonId: student.LessonId,
        Notes: student.Notes,
        StartTime: student.StartTime,
        StudentEmailId: student.StudentEmailId,
        StudentName: student.StudentName,
      };
    });
    axios
      .post(
        `${url}/api/record/take-attendence${this.props.user.slug}`,
        chkRecords,
        {
          headers: headers,
        },
      )
      .then((res) => {
        this.setState({ checkedRecords: res.data.result });
        this.fetchRecordsByLesson();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };
  checkedRecordsModeHandler = (body) => {
    axios
      .post(
        `${url}/api/student/update-student-class-mode${this.props.user.slug}`,
        body,
        {
          headers: headers,
        },
      )
      .then((res) => {
        // this.setState({ checkedRecords: res.data.result });
        // this.fetchRecordsByLesson();
        this.analyticsHandler();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };
  takeAttendance = (email, lsn, attendance, takenBy) => {
    this.changeRecordState(email, lsn, attendance, takenBy);
    axios
      .put(
        `${url}/api/record/update-student-attendance${this.props.user.slug}`,
        {
          StudentEmailId: email,
          LessonId: lsn,
          Attendance: attendance,
          AttendanceTakenBy: this.props.user.username,
        },
        { headers: headers },
      )
      .then((res) => {
        const response = res.data;
        if (response.status !== "Success") {
          // console.log("Attendance Updation Failed!");
        }
      })
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  changeRecordState = (email, lsn, attendance, takenBy) => {
    const foundRecord = this.state.showRecords.find((stud) => {
      return stud.StudentEmailId === email
        ? stud.LessonId === lsn
          ? stud.LessonId === lsn
          : null
        : null;
    });
    const foundIndex = this.state.showRecords.findIndex((stud) => {
      return stud.StudentEmailId === email
        ? stud.LessonId === lsn
          ? stud.LessonId === lsn
          : null
        : null;
    });
    let recordData = [...this.state.showRecords];
    foundRecord.Attendance = attendance;
    foundRecord.AttendanceTakenBy = this.props.user.username;
    recordData[foundIndex] = foundRecord;
    this.setState({ showRecords: recordData });
  };

  analyticsHandler = () => {
    let analytics = {
      virtual: 0,
      total: 0,
      present: 0,
      absent: 0,
      late: 0,
      justification: 0,
    };
    this.state.showRecords.map((student) => {
      analytics.total++;
      if (student.ClassType === "Virtual") {
        analytics.virtual++;
      }
      if (student.Attendance === "Presente") {
        analytics.present++;
      } else if (student.Attendance === "Ausente") {
        analytics.absent++;
      } else if (student.Attendance === "Retardo") {
        analytics.late++;
      } else if (
        student.Attendance === "Sickness" ||
        student.Attendance === "Family emergency" ||
        student.Attendance === "Not feel well"
      ) {
        analytics.absent++;
        analytics.justification++;
      }
      return null;
    });
    this.setState({ showRecordsAnalytics: analytics });
  };

  pinnedHandler = (isVirtual, email) => {
    axios
      .put(
        `${url}/api/student/update-student-present-mode${this.props.user.slug}`,
        {
          isVirtual: isVirtual,
          StudentEmailID: [email],
        },
        { headers: headers },
      )
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  onCompactModeHandler = () => {
    const { isCompactMode } = this.state;
    this.setState({
      ...this.state,
      isCompactMode: !isCompactMode,
    });
  };

  controlsStateHandler = () => {
    return {
      ...this.state,
      // showLesson: [],
      ...{ accessToken: this.props.user.accessToken },
    };
  };

  openPanel = () => {
    this.setState({ isOpen: true });
  };

  dismissPanel = () => {
    this.setState({ isOpen: false });
  };

  getCurrentLanguage() {
    const languageMappings = {
      en: "en",
      "en-GB": "en",
      "en-US": "en",
      es: "es",
      pt: "pt",
      de: "de",
      fr: "fr",
      hi: "hi",
      // Add other languages as needed
    };
    return languageMappings[i18n.language];
  }

  render() {
    const {
      currentAssignmentData,
      hasAnyFormData,
      isCreatingNew,
      currentAssignmentData_,
      newAssignmentInitialValues,
      setIsCreatingNew,
    } = this.context;

    const { t } = this.props;
    const { isCompactMode } = this.state;
    const currentLanguage = this.getCurrentLanguage();
    const styles = {
      cardImg: {
        width: "72px",
        height: "56px",
        right: "220px",
        marginLeft: "6px",
        marginTop: "6px",
        marginBottom: "6px",
        borderRadius: "7px",
      },
      topic: {
        display: this.state.showTopic ? "block" : "none",
        position: "absolute",
        left: this.state.isSmall ? 0 : "20px",
        bottom: this.state.isSmall ? 0 : "20px",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
        minHeight: "260px",
        width: this.state.isSmall ? "-webkit-fill-available" : "340px",
        background: "white",
        borderRadius: "5px",
        zIndex: 2,
      },
      notes: {
        display: this.state.showNote ? "block" : "none",
        position: "absolute",
        left: this.state.isSmall ? 0 : this.state.showTopic ? "380px" : "20px",
        bottom: this.state.isSmall ? 0 : "20px",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
        minHeight: "260px",
        width: this.state.isSmall ? "-webkit-fill-available" : "340px",
        background: "white",
        borderRadius: "5px",
        zIndex: 2,
      },
      present: { backgroundColor: "#2F80ED", color: "white" },
      absent: {
        backgroundColor: "#EB5757",
        color: "white",
        marginLeft: "-10px",
      },
      justify: {
        backgroundColor: "#17a2b8",
        color: "white",
        marginLeft: "-10px",
      },
      home: { backgroundColor: "#04c68a", color: "white", marginLeft: "-10px" },
      late: { backgroundColor: "#464775", color: "white", marginLeft: "-10px" },
      btnPresent: { minWidth: "70px", marginLeft: "-10px" },
      btnAbsent: { minWidth: "66px", marginLeft: "-10px" },
      btnLate: { minWidth: "48px", marginLeft: "-10px" },
      btnHome: { minWidth: "48px", marginLeft: "-10px" },
      hideText: {
        whiteSpace: "nowrap",
        width: "180px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    };

    const showTopicHandler = () => {
      this.handleResize("TOPIC");
      // this.setState({ showTopic: !this.state.showTopic });
    };

    const showNoteHandler = () => {
      this.handleResize("NOTE");
      // this.setState({ showNote: !this.state.showNote });
    };

    const convertUtcToLocalTime = (utcDate, utcTime) => {
      return moment.utc(`${utcDate} ${utcTime}`).local().format("HH:mm");
    };

    const myCard = (lsn) => {
      const TextWithTooltip = ({ lsn }) => {
        const classPart1 = lsn.ClassName.split("-")[1];
        const classPart2 = lsn.ClassName.split("-")[2];
        const tooltipText = `${classPart1} - ${classPart2}`;

        // Detect mobile device
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        if (isMobile) {
          // 🟢 MOBILE → use Popup (click trigger)
          const handleClick = (e) => {
            e.stopPropagation(); // prevent parent card click
          };

          return (
            <Popup
              content={tooltipText}
              trigger={
                <div onClick={handleClick}>
                  <Text
                    content={tooltipText}
                    data-text={tooltipText}
                    size="small"
                    style={styles.hideText}
                  />
                </div>
              }
              on="click"
              position="above"
              align="center"
            />
          );
        } else {
          // 🟣 DESKTOP → use Tooltip (hover trigger)
          return (
            <Tooltip
              content={tooltipText}
              trigger={
                <Text
                  content={tooltipText}
                  data-text={tooltipText}
                  size="small"
                  style={styles.hideText}
                />
              }
            />
          );
        }
      };
      // const cardToolTip = lsn.ClassName.split("-")[0];

      let date = moment.utc(`${lsn.LessonDate}`).local().format("YYYY-MM-DD");

      const localStartTime = convertUtcToLocalTime(
        moment(lsn.LessonDate).format("YYYY-MM-DD"),
        lsn.StartTime,
      );
      const localEndTime = convertUtcToLocalTime(
        moment(lsn.LessonDate).format("YYYY-MM-DD"),
        lsn.EndTime,
      );

      const cardToolTip = `${localStartTime + " - " + localEndTime}   ${date}
      <br />${lsn.ClassName.split(" - ")[0]}<br />${
        lsn.ClassName.split(" - ")[1]
      }`;
      // const cardToolTip = `${
      //   lsn.StartTime.trim() + " - " + lsn.EndTime.trim()
      // }   ${date}
      // <br />${lsn.ClassName.split(" - ")[0]}<br />${
      //   lsn.ClassName.split(" - ")[1]
      // }`;

      const lessonTitle = lsn?.Title ? lsn.Title : lsn?.LessonId;
      const stateLessonTitle = this.state.selectedLesson?.Title
        ? this.state.selectedLesson.Title
        : this.state.selectedLesson?.LessonId;

      return (
        <>
          <Card
            key={lessonTitle}
            data-cy-lessonId={lsn.Title}
            style={{
              marginBottom: "10px",
              borderRadius: "7px",
              cursor: "pointer",
              border: "2px solid #d3d3d314",
              width: "auto",
            }}
            className={
              this.state.selectedLesson
                ? lessonTitle === stateLessonTitle
                  ? "selectedCard"
                  : "card"
                : "card"
            }
            compact
            horizontal
            aria-roledescription="ACV - Asistente de clases virtuales | Tangible IT"
            onClick={async () => {
              // const isDirty =
              //   currentAssignmentData?.assignmentTitle?.trim() ||
              //   currentAssignmentData.instructionStyle?.instructionHtmlString?.trim() ||
              //   currentAssignmentData?.attachments?.some((a) =>
              //     Array.isArray(a.info) ? a.info.length > 0 : !!a.info,
              //   ) ||
              //   (currentAssignmentData?.rubric &&
              //     Object.keys(currentAssignmentData.rubric).length > 0);

              const isDirty = hasAnyFormData(
                currentAssignmentData,
                isCreatingNew,
              );

              // 🛑 BLOCK IF FORM HAS UNSAVED CHANGES
              if (isDirty) {
                this.setState({
                  showLessonSwitchConfirm: true,
                  pendingLesson: lsn,
                });
                return;
              }

              this.dismissPanel();
              if (!document.querySelector(".Assignment.h-cls")) {
                document.querySelector(".Assignment").classList.add("h-cls");
              }
              if (
                this.state.showTopic !== true &&
                this.state.showNote !== true
              ) {
                this.setState({
                  load: true,
                  checkedRecords: [],
                  checkedRecordsMode: [],
                  selectedLesson: await lsn,
                });

                this.fetchRecordsByLesson();
                this.props.history.push("/assignments");
                // document.getElementById("textLessonTopic").value =
                //   this.state.selectedLesson.Tema;
                // document.getElementById("textLessonNote").value =
                //   this.state.selectedLesson.Tarea;
              } else {
                console.log("Please Handel opened window first!");
              }
            }}
            data-cy="available-class"
          >
            {this.state.isCompactMode && (
              <ReactTooltip
                place="right"
                type="light"
                effect="float"
                multiline={true}
              />
            )}
            <Card.Preview
              horizontal
              data-tip={cardToolTip}
              styles={{ marginRight: "0.3025rem" }}
            >
              <Image
                style={styles.cardImg}
                src={
                  lsn?.LessionData
                    ? lsn?.LessionData.lessonImage?.ImageURL
                      ? lsn.LessionData.lessonImage.ImageURL +
                        this.props?.user?.SASToken
                      : lsn.ClassName.includes("Art")
                        ? Imgart
                        : lsn.ClassName.includes("Civismo")
                          ? Imgcivil
                          : lsn.ClassName.includes("Hist")
                            ? Imghistory
                            : lsn.ClassName.includes("Science")
                              ? ImgnaturalScience
                              : lsn.ClassName.includes("losof")
                                ? Imgphilosophy
                                : lsn.ClassName.includes("Ciencias Exactas")
                                  ? ImgscienceExact
                                  : lsn.ClassName.includes("Tec")
                                    ? Imgtech
                                    : Imgother
                    : lsn?.lessonImage?.ImageURL
                      ? lsn.lessonImage.ImageURL + this.props?.user?.SASToken
                      : lsn.ClassName.includes("Art")
                        ? Imgart
                        : lsn.ClassName.includes("Civismo")
                          ? Imgcivil
                          : lsn.ClassName.includes("Hist")
                            ? Imghistory
                            : lsn.ClassName.includes("Science")
                              ? ImgnaturalScience
                              : lsn.ClassName.includes("losof")
                                ? Imgphilosophy
                                : lsn.ClassName.includes("Ciencias Exactas")
                                  ? ImgscienceExact
                                  : lsn.ClassName.includes("Tec")
                                    ? Imgtech
                                    : Imgother
                }
              />
            </Card.Preview>
            <Card.Column className={isCompactMode ? "d-none" : ""}>
              <Card.Header>
                <Flex gap="gap.small">
                  <Text
                    content={localStartTime + " - " + localEndTime}
                    size="small"
                    style={{ marginTop: "6px" }}
                  />
                  <Text
                    content={
                      this.state.isDateSelected
                        ? moment
                            .utc(lsn.LessonDate)
                            .local()
                            .format("YYYY-MM-DD")
                        : moment(new Date()).format("YYYY-MM-DD")
                    }
                    size="small"
                    style={{ marginTop: "6px" }}
                  />
                </Flex>
                <Text
                  content={lsn.ClassName.split("-")[0]}
                  weight="semibold"
                  style={styles.hideText}
                />
                <TextWithTooltip lsn={lsn} />
              </Card.Header>
            </Card.Column>
          </Card>
        </>
      );
    };

    const onDateDataChange = async (date) => {
      this.setState({ selectedDate: await date });

      fetchLessons();
    };
    const postCrossDomainMessage = () => {
      const iframeEl = document.getElementsByClassName(
        "avatar-video-generator-1",
      );
      // Make sure you are sending a string, and to stringify JSON
      iframeEl[0]?.contentWindow?.postMessage(
        {
          source: "gan",
          message: { accessToken: this.props.user.accessToken },
        },
        process.env.REACT_APP_GAN,
      );
    };

    return (
      // <AssignmentContext>
      <div className="Assignment h-ctr">
        <Dialog
          style={{
            maxWidth: "450px",
          }}
          open={this.state.showLessonSwitchConfirm}
          header="Discard changes?"
          content="You have unsaved changes in this assignment. Switching lessons will discard them."
          confirmButton="Discard & Switch"
          cancelButton="Cancel"
          onConfirm={() => {
            this.setState(
              {
                showLessonSwitchConfirm: false,
                load: true,
                checkedRecords: [],
                checkedRecordsMode: [],
                selectedLesson: this.state.pendingLesson,
                pendingLesson: null,
                isCreatingRubric: false,
              },
              () => {
                this.context.setCurrentAssignmentData(
                  newAssignmentInitialValues,
                );
                this.context.setCurrentAssignmentData_(
                  newAssignmentInitialValues,
                );

                this.fetchRecordsByLesson();
                setIsCreatingNew(false);
                // this.props.history.push("/assignments");
              },
            );
          }}
          onCancel={() =>
            this.setState({
              showLessonSwitchConfirm: false,
              pendingLesson: null,
            })
          }
        />

        <Dialog
          open={this.state.isOpenAvatarGenerator}
          onLoad={postCrossDomainMessage}
          className="generate-avatar-dialog"
          content={
            <iframe
              className="avatar-video-generator-1"
              src={`${process.env.REACT_APP_GAN}${this.props.user.slug}&owner=${
                this.props.user.mail
              }&lessonID=${
                this.state.selectedLesson?.Title
              }&language=${currentLanguage}&host=gan.acv.app&gpu=0&database=${
                process.env.REACT_APP_STORAGE === "acvstgpreprod"
                  ? "preprod"
                  : "prod"
              }`}
              style={{
                height: "calc(100vh - 190px)",
                width: "100%",
                border: 0,
              }}
            ></iframe>
          }
          headerAction={{
            icon: <CloseIcon />,
            title: "Close",
            onClick: () => this.setState({ isOpenAvatarGenerator: false }),
          }}
        />
        {this.props?.user?.actualRole === "SuperAdmin" ? (
          <Dialog
            open={this.state.dialog}
            onConfirm={() => this.setState({ dialog: false })}
            confirmButton="Okay"
            content={
              "Your Plan will expire on " +
              (this.state.ExpirationDate
                ? moment(this.state.ExpirationDate).format("MMMM D, YYYY")
                : "-") +
              ". Request for renewal ASAP!"
            }
            header="Your ACV Plan"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () => this.setState({ dialog: false }),
            }}
          />
        ) : null}
        <Dialog
          open={this.state.accDlg}
          onConfirm={() => location.reload()}
          confirmButton="Refresh Now"
          content={
            <p className="refreshMsg">
              No big deal — but we need to refresh to show your content.
            </p>
          }
          header="Authorization expire"
        />
        <div
          style={{
            position: "relative",
          }}
        >
          {!this.state.isExpire &&
            this.state.isSubscribed &&
            this.props.isShowControl && (
              <Controls
                isCompactMode={isCompactMode}
                myCard={myCard}
                state={{
                  ...this.controlsStateHandler(),
                }}
                user={this.props.user}
                labels={t("assignment").controls}
                cLabels={t("AttendanceHistory").controls}
                onDateDataChange={async (date) => {
                  this.setState({
                    selectedDate: await date,
                    isDateSelected: true,
                    getSelectedData: date,
                  });
                  this.fetchLessons();
                }}
                changeLsnByClass={async (e) => {
                  this.setState({ selectedClass: await e });
                  this.fetchLessons();
                }}
                changeLsnByTeacher={async (e) => {
                  this.setState({ selectedTeacher: await e });
                  this.fetchLessons();
                }}
                resetSelected={() => {
                  this.setState(
                    {
                      selectedClass: null,
                      selectedTeacher: null,
                    },
                    () => this.fetchLessons(),
                  );
                }}
                fetchRcrd={() => this.fetchRecordsByLesson()}
                assignmentSearch={true}
                isLessonsAvailable={!!this.state.showLesson?.length}
                showNote={
                  this.state.selectedLesson ? showNoteHandler.bind() : null
                }
                isOpen={this.state.isOpen}
                openPanel={this.openPanel}
                dismissPanel={this.dismissPanel}
              />
            )}
        </div>
        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute", top: 0, left: 0, right: 0 }}>
            <CustomProgressIndicator
              isLoading={this.state.load}
              style={{
                progressTrack: {
                  backgroundColor: "#ffffff",
                },
              }}
            />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            overflow: "auto",
            backgroundColor: "white",
          }}
          className="main"
        >
          {
            <Flex
              gap="gap.medium"
              wrap
              className={
                !this.state.isCreatingRubric
                  ? `container2 ${
                      !this.state.selectedLesson ? "" : "d-sm-center"
                    }`
                  : "container2"
              }
            >
              {this.state.isSubscribed &&
              this.state.showLesson &&
              this.state.showLesson.length &&
              !this.state.isExpire &&
              !this.state.isCreatingRubric ? (
                <Flex
                  gap="gap.medium"
                  className={`tour-select-lesson assignment-availableClass ${
                    isCompactMode ? "mr-0" : ""
                  } ${
                    this.state.selectedLesson ? "assignment-class-selected" : ""
                  }`}
                >
                  {(this.props.user.slug === "?slug=acvpreprod" ||
                    this.props.user.slug === "?slug=acvapp") &&
                  (this.state.selectedDay === "Sunday" ||
                    this.state.selectedDay === "Saturday") ? null : (
                    <>
                      <div
                        style={{
                          paddingTop: "18px",
                          width: isCompactMode ? "auto" : "280px",
                          paddingLeft: "40px",
                          marginRight: "0px",
                        }}
                      >
                        <Label
                          style={{ color: "#252423", cursor: "pointer" }}
                          iconPosition="start"
                          icon={
                            isCompactMode ? <IndentIcon /> : <NumberListIcon />
                          }
                          content={
                            isCompactMode ? (
                              ""
                            ) : (
                              <Text
                                content={t("assignment").body.lessions}
                                size="medium"
                                weight="semibold"
                                style={{ marginLeft: "4px" }}
                              />
                            )
                          }
                          color="white"
                          onClick={() => this.onCompactModeHandler()}
                        />
                      </div>

                      <AvailbleClass
                        isCompactMode={isCompactMode}
                        state={this.state}
                        myCard={myCard}
                      />
                    </>
                  )}
                </Flex>
              ) : null}
              {(!this.state.isSubscribed && !this.state.load) ||
              this.state.isExpire ? (
                <Subscription
                  pageName="assignment"
                  isExpire={this.state.isExpire}
                  role={this.props.user.role}
                />
              ) : (
                <Flex
                  gap={!this.state.isCreatingRubric ? "gap.medium" : null}
                  wrap
                >
                  {
                    <div
                      className={
                        this.state.isCreatingRubric
                          ? "assignment-table-wrapper-w-100 table-wrapper w-100 btsp "
                          : [
                              !this.state.selectedTeacher &&
                              !this.state.selectedClass &&
                              !this.state.showLesson?.length
                                ? "table-wrapper w-100"
                                : "table-wrapper",
                              isCompactMode ? "table-wrapper-w-100" : "",
                            ].join(" ") + " btsp"
                      }
                    >
                      {!this.state.selectedLesson ? (
                        <figure
                          className="w-100"
                          style={{
                            display: "flex",
                            height: "100%",
                            margin: "auto",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            alt="ACV - Tangible IT"
                            src={AssignmentHomeSvg}
                            style={{
                              maxWidth: "50%",
                            }}
                            draggable="false"
                          />
                        </figure>
                      ) : (
                        <AssignmentHome
                          key={
                            this.state.selectedLesson?.LessonId ||
                            this.state.selectedLesson?.Title
                          }
                          {...this.props}
                          isSmall={this.state.isSmall}
                          isCompactMode={isCompactMode}
                          showLesson={this.state.showLesson}
                          selectedLesson={this.state.selectedLesson}
                          showRecords={this.state.showRecords}
                          setSelectedLesson={(lesson) =>
                            this.setState({ selectedLesson: lesson })
                          }
                          state={this.state}
                          setState={(data) => {
                            this.setState(data);
                          }}
                          showLessonSwitchConfirm={
                            this.state.showLessonSwitchConfirm
                          }
                        />
                      )}
                    </div>
                  }
                </Flex>
              )}
            </Flex>
          }
        </div>
      </div>
      // </AssignmentContext>
    );
  }
}
export default withTranslation()(Assignment);
